import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';
import { LoaderService } from './services/loader.service';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {

  private readonly DEFAULT_TIMEOUT = 60000;

  constructor(
    private loadingService: LoaderService
  ) {}

  intercept(
    request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    console.log('Timeout Interceptor Working');
    
    return next.handle(request).pipe(
      timeout(this.DEFAULT_TIMEOUT),
      catchError((error) => {
        console.error('Request timed out or failed:', error);
        throw error;
      })
    );
  }
}
